class PjjobsdropdownController {
  constructor($rootScope, $scope, $state, $localStorage, $location) {
    this.name = "pjjobsdropdown";
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$location = $location;
    this.$localStorage = $localStorage;
    this.$scope = $scope;

    var _this = this;

    _this.SetEventsToJobsScrollListener = _this.$rootScope.$on("SetEventsToJobsScroll", function (event, params) {
      if (!_this.events) {
        _this.events = _this.$localStorage.events;
      }
    });

    _this.ListEventsForScrollListener = _this.$rootScope.$on("ListEventsForScroll", function (event, params) {
      _this.events = _this.$localStorage.events;
    });

    _this.SetHoverDataListener = _this.$rootScope.$on("SetHoverData", function (event, params) {});

    _this.$scope.$on("$destroy", _this.SetEventsToJobsScrollListener);
    _this.$scope.$on("$destroy", _this.ListEventsForScrollListener);

    _this.setEventsInDropDown();
  }

  goToJobs() {
    var _this = this;
    _this.$state.go("jobsdashboard");
  }

  goToJobOverview(event) {
    var _this = this;
    _this.$location.path("/event/" + event.id + "/overview");
  }

  showJobScroll() {
    var _this = this;
    if (_this.showJobsDropDown === false) {
      _this.$timeout(function () {
        _this.events = _this.$localStorage.events;
        _this.showJobsDropDown = true;
        $(".hidden-drop-down").show("fast");
      }, 300);
    } else {
      _this.$timeout(function () {
        _this.showJobsDropDown = false;
        $(".hidden-drop-down").hide("fast");
      }, 300);
    }
  }

  setEventsInDropDown() {
    var _this = this;
  }
}

PjjobsdropdownController.$inject = ["$rootScope", "$scope", "$state", "$localStorage", "$location"];

export default PjjobsdropdownController;



// WEBPACK FOOTER //
// ./client/app/common/pjheader/pjjobsdropdown/pjjobsdropdown.controller.js